"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CobaltIcon = _interopRequireDefault(require("../../components/CobaltIcon"));

var BreadcrumbsTheme = function BreadcrumbsTheme(colors) {
  return {
    defaultProps: {
      separator: /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
        name: "chevron-right"
      })
    },
    styleOverrides: {
      root: {
        color: colors.lynch
      },
      ol: {
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        margin: 0,
        listStyle: 'none'
      },
      separator: {
        display: 'flex',
        alignItems: 'center',
        color: colors.lynch,
        margin: '0 4px',
        fontSize: '20px'
      },
      li: {
        display: 'flex',
        alignItems: 'center'
      }
    }
  };
};

var _default = BreadcrumbsTheme;
exports["default"] = _default;